package pl.finn.forms.podpp

object PodppData {

  val documentTypeMap = mapOf(
    "wniosek" to "Wniosek",
    "podanie" to "Podanie",
    "skarga" to "Skarga",
    "zażalenie" to "Zażalenie",
    "odwołanie" to "Odwołanie",
    "informacja" to "Informacja",
    "zawiadomienie" to "Zawiadomienie",
    "opinia" to "Opinia",
    "decyzja" to "Decyzja",
    "postanowienie" to "Postanowienie",
    "wezwanie" to "Wezwanie",
    "zaświadczenie" to "Zaświadczenie",
    "inne pismo" to "Inne pismo"
  )

}